// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__k8C11","tagLabel":"tag_tagLabel__obo94","tagCloseButton":"tag_tagCloseButton__V7aSj","tagCloseIcon":"tag_tagCloseIcon__Ow2Jt"};